import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalForm, ModalFormContainer } from "../../../../theme";
import Select from "react-select-plus";
import { isAccess } from "../../../../common/utils";
import { debounce } from "../../../../../helpers/common";
import Creatable from "react-select-plus/lib/Creatable";

export class FlowTemplateAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Flow Template`;
    this.moduleUrl = `flow-template`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
    this.assignedToOptions = [
      { value: "message", label: "Message" },
      { value: "voice", label: "Voice" },
    ];
    // this.state = {
    //   options: [],
    // };
  }
  setData(editData = {}) {
    console.log("editData", this.props.tagList);
    editData = editData || {};
    this.state = {
      name: editData.name || "",
      type: editData.type || "",
      tag: editData.tag || "",
      icon: editData.icon || "",
      file: editData.file || null,
      description: editData.description || "",
      options: [],
      actions: editData.actions || {},
      elements: editData.elements || [],
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: "",
      type: "",
      tag: "",
      icon: "",
      file: null,
      description: "",
      selectedTags: [],
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
    }
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;
    // let formData = new FormData();
    // formData.append('name', _this.state.name);
    // formData.append('type', _this.state.type);
    // formData.append('tag', _this.state.tag);
    // formData.append('icon', _this.state.icon);
    // formData.append('file', _this.state.file);
    // formData.append('description', _this.state.description);
    // console.log('fromData1122', formData)
    let tData = {
      name: this.state.name,
      type: this.state.type,
      tag: this.state.tag,
      icon: this.state.icon,
      // file: this.state.file,
      description: this.state.description,
      actions: this.state.actions,
      elements: this.state.elements,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: this.props.editData._id },
        "PUT"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.closeModal(true);
          _this.props.update();
          Alert.success(`${this.moduleName} created successfully.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public"
      );
    }
  }

  generateParamsFromArray(tData) {
    return tData.map((tD) => ({
      value: tD.value,
      label: tD.label,
    }));
  }

  // handleTagChange = (value) => {
  //   console.log('value1122', value.value)
  //   this.setState({ tag: value });
  // };

  handleTagChange = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    this.setState({ tag: selectedOption ? selectedOption.value : "" });
  };

  generateTypeParams(tData) {
    return tData.map((entity) => ({
      value: entity,
      label: entity,
    }));
  }

  render() {
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Name", {
                defaultValue: "",
                placeholder: "Name",
                autoFocus: true,
                required: true,
                id: "name",
                value: this.state.name,
                onChange: (e) => {
                  if (e.target.value === " " || e.target.value.length > 20) {
                    return false;
                  }
                  this.setState({
                    name: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel>Type</ControlLabel>
                <Select
                  defaultValue=""
                  placeholder="Type"
                  onChange={(item) => {
                    if (item) {
                      this.setState({ type: item.value || "message" });
                    } else {
                      this.setState({ type: null });
                    }
                  }}
                  disabled={
                    this.state.disabled === true
                      ? true
                      : !this.props.editData || !this.props.editData._id
                      ? false
                      : true
                  }
                  value={this.assignedToOptions.find(
                    (option) => option.value === this.state.type
                  )}
                  // editable={false}
                  options={this.generateParamsFromArray(this.assignedToOptions)}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              <FormGroup>
                <ControlLabel required>Select Tag</ControlLabel>
                {/* <Select.Creatable
                  multi={false}
                  // onChange={(value) => this.handleTagChange(value)}
                  // value={this.state.options.find(
                  //   (option) => option.value === this.state.tag
                  // )}
                  value={this.state.tag}
                  options={this.generateTypeParams([this.props.tagList])}
                  onChange={selectedOption => {
                    let t = selectedOption ? selectedOption.value : '';
                    this.setState({ tag: t });
                  }}
                /> */}
                <Creatable
                  isClearable
                  onChange={this.handleTagChange}
                  value={
                    this.state.tag
                      ? { value: this.state.tag, label: this.state.tag }
                      : null
                  }
                  options={this.generateTypeParams(this.props.tagList)}
                />
              </FormGroup>
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Icon (React Icons - Font Awesome 5)", {
                defaultValue: "",
                placeholder: "React Icon",
                // disabled:
                //   this.state.disabled === true
                //     ? true
                //     : !this.props.editData || !this.props.editData._id
                //     ? false
                //     : true,
                autoFocus: false,
                required: true,
                id: "icon",
                value: this.state.icon,
                onChange: (e) => {
                  if (e.target.value === " " || e.target.value.length > 20) {
                    return false;
                  }
                  this.setState({
                    icon: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          {!(this.props.editData && this.props.editData._id) && (
            <FormWrapper>
              <FormColumn className="w-100">
                {this.renderFormGroup("File", {
                  defaultValue: "",
                  labelRequired: true,
                  componentClass: "file",
                  type: "file",
                  value: "",
                  accept: "application/json",
                  selectedFile: this.state.file,
                  onChange: (e) => {
                    const file = e.target.files[0];
                    console.log("e.target.files[0]", e.target.files[0]);
                    let result;
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = (event) => {
                        const fileContent = event.target.result;
                        result = JSON.parse(event.target.result);
                        console.log("File content:", result);
                        this.setState({
                          actions: result.actions,
                          elements: result.elements,
                        });
                      };
                      reader.readAsText(file);
                    }

                    if (e.target.files && e.target.files[0]) {
                      this.setState({ file: e.target.files[0] });
                    } else {
                      this.setState({ file: null });
                    }
                  },
                  id: "file",
                })}
              </FormColumn>
            </FormWrapper>
          )}

          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Description", {
                placeholder: "Add Description here...",
                componentClass: "textarea",
                defaultValue: "",
                required: true,
                id: "description",
                style: { padding: "20px" },
                value: this.state.description,
                onChange: (e) => {
                  this.setState({
                    description: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            // btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            disabled={this.state.loading}
            type="blueModalBtn"
            btnType="submit"
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

FlowTemplateAddEdit.propTypes = {
  group: PropTypes.array,
};

FlowTemplateAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default FlowTemplateAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/FlowTemplate/components/FlowTemplateAddEdit.js